'use client';

import { usePaddleContext } from '@/features/subscription/contexts/Paddle';

export default function usePaddle() {
  const { paddleInstance } = usePaddleContext();
  return paddleInstance ?? undefined;
}
